module.exports = __webpack_public_path__ + "media/images/avatar/development/nannies/5-648bc108af251b0b4c2b0b402e044c4c.jpg";